import { ApolloLink, from, split } from 'apollo-link';
import { onError } from 'apollo-link-error';
import { HttpLink } from 'apollo-link-http';
// import { Message } from 'element-ui'
import { apiUrl1, apiUrl2 } from './url.js';
import fetch from 'unfetch';
import Cookies from 'js-cookie';
import { Notice } from 'iview';

const httpLink1 = new HttpLink({
    uri: apiUrl1,
    credentials: 'same-origin',
    fetch: fetch
});

const httpLink2 = new HttpLink({
    uri: apiUrl2,
    credentials: 'same-origin',
    fetch: fetch
});

const isUsingApi1 = (operation) => {
    const context = operation.getContext();
    return context.useApi1 !== false;
};

const httpLink = split(
    isUsingApi1,
    httpLink1,
    httpLink2
);

const authMiddleware = new ApolloLink((operation, forward) => {
    // add the authorization to the headers
    const token = Cookies.getJSON('token');
    if (operation.operationName !== 'login') {
        operation.setContext({
            headers: {
                authorization: `Bearer ${token || null}`
            }
        });
    };
    return forward(operation);
});

const checkCodeLink = new ApolloLink((operation, forward) => {
    return forward(operation).map(response => {
        if (
            response.data[operation.operationName] &&
            response.data[operation.operationName].code === 401
        ) {
            // TODO
            // 根据状态码处理
            Notice.destroy();
            Notice.open({
                title: '登录超时,请重新登录'
            });
        };
        return response;
    });
});

const errorLink = onError(({ networkError, graphQLErrors }) => {
    if (graphQLErrors && graphQLErrors[0].extensions.code === 'UNAUTHENTICATED') {
        // TODO
        // 这里跳转到登录重新授权
        Cookies.remove('token');
        Notice.destroy();
        Notice.open({
            title: '登录超时,请重新登录'
        });
        setTimeout(() => {
            window.location.href = 'https://all.madagx.com/';
        }, 3000);
    } else {
        Notice.destroy();
        // Notice.open({
        //     title: '服务繁忙， 请稍后刷新'
        // });
    }
});

export const link = from([
    authMiddleware,
    checkCodeLink,
    errorLink,
    httpLink
]);



// WEBPACK FOOTER //
// ./src/graphql/apply-ware.js